import React, { useEffect, useState } from "react";

/**
 * Hook to determine if Element is in view.
 * Based loosely on: https://github.com/thebuilder/react-intersection-observer
 *
 * @param threshold - The threshold at which the element is considered in view. 1 for fully in view
 *  and lower number for percentage less than full to trigger is in view.
 * @returns An object containing the ref to attach to the element and a boolean indicating if the
 *  element is in view.
 */
const useInView = (threshold = 0.01) => {
  const [ref, setRef] = React.useState<Element | null>(null);

  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!ref) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsInView(entry.isIntersecting);
        });
      },
      {
        threshold,
      },
    );
    observer.observe(ref);

    return () => {
      observer.disconnect();
    };
  }, [ref, threshold]);

  return { ref: setRef, isInView };
};

export { useInView };
